d:\项目\搏亿购\boyigou_web\boyigou_web_new\src\components\HomeBody\HomeBodyThird.vue
<template>
    <div class="home-body-third">
        <div class="hot-sales-section">
            <!-- 标题栏 -->
            <div class="section-header">
                <div class="section-title">商家热销</div>
                <div class="search-box">
                    <input type="text" placeholder="请输入关键词" class="search-input" v-model="keyword"
                        @keyup.enter="getRexiao">
                    <button class="search-btn" @click="getRexiao">
                        <img src="../../assets/images/13.png" alt="">
                    </button>
                </div>
            </div>

            <!-- 商品分类与推荐 -->
            <div class="category-recommendation" v-for="(item, index) in rexiaoList" :key="index">
                <!-- 水果分类 -->
                <div class="category-item">
                    <div class="category-content">
                        <div class="category-header fruit"
                            :style="{ backgroundImage: `url(${item.pc_picture})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
                            <div class="category-icon fruit-icon"></div>
                            <div class="category-info" style="display: flex; flex-direction: column; ">
                                <div class="category-title">{{ item.name }}</div>
                                <div class="category-subtitle">{{ item.pc_sub_title }}</div>
                            </div>
                        </div>

                        <!-- 分类列表 -->
                        <div class="category-list">
                            <div class="category-group" v-for="(value, index1) in item.children" :key="index1">
                                <div class="group-title">{{ value.name }}</div>
                                <div class="group-items">
                                    <span class="group-item" v-for="(value1, index2) in value.goods" :key="index2"
                                        @click="handleClick(value1)">{{ value1.name }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 好货推荐 -->
                        <div class="recommendation">
                            <div class="recommendation-title">好货推荐</div>
                            <div class="recommendation-items">
                                <div class="recommendation-item" v-for="product in item.recommendList"
                                    :key="product.aid" @click="goShopDetails(product)">
                                    <div class="product-image">
                                        <img :src="product.thumb" :alt="product.name">
                                    </div>
                                    <div class="product-price">¥{{ product.shop_price }}/{{ product.unit }}</div>
                                    <div class="product-name">{{ product.name }}</div>
                                    <div class="product-sales">销量{{ product.sales_sum }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeBodyThird',
    data() {
        return {
            keyword: '',
            rexiaoList: [],
        }
    },
    created() {
    },
    mounted() {
        this.getRexiao();
    },
    methods: {
        // 获取热销商品
        getRexiao() {
            this.$api.getRexiao({
                keyword: this.keyword,
            }).then(res => {
                this.rexiaoList = res.map(item => {
                    // 给每个商品补上所属一级分类的 pid，方便点击时定位
                    if (item.children && item.children.length > 0) {
                        item.children.forEach(child => {
                            if (child.goods && child.goods.length > 0) {
                                child.goods.forEach(good => {
                                    good.pid = item.aid;
                                });
                            }
                        });
                    }
                    // 默认取第一个分类下第一个商品的 recommend 数组
                    const firstChild = item.children && item.children.length > 0 ? item.children[0] : null;
                    const firstGoods = firstChild && firstChild.goods && firstChild.goods.length > 0 ? firstChild.goods[0] : null;
                    return {
                        ...item,
                        recommendList: firstGoods && firstGoods.recommend ? firstGoods.recommend : []
                    };
                });
                console.log('处理后的rexiaoList:', this.rexiaoList);
            }).catch(err => {
                // console.error('获取热销商品失败:', err);
                this.$message.error(err);
            });
        },



        handleClick(item) {
            // 直接通过引用更新数据，确保Vue能够检测到变化
            const targetItem = this.rexiaoList.find(ele => String(ele.aid) === String(item.pid));
            if (targetItem) {
                // 使用Vue.set确保响应式更新，取当前点击商品下的 recommend 数组
                this.$set(targetItem, 'recommendList', item.recommend ? [...item.recommend] : []);
            } else {
                // console.error('未找到匹配的分类');
                this.$message.warning('未找到对应的分类');
            }
        },
        goShopDetails(product) {
            this.$router.push({
                path: '/ShopDetails',
                query: {
                    id: product.aid
                }
            })
        },
    },

}
</script>

<style scoped>
.home-body-third {
    width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
}

/* 热销区域 */
.hot-sales-section {
    /* border: 1px solid #d0d0d0; */
    border-radius: 4px;
    overflow: hidden;
    background-color: #ffffff;
    padding: 0 20px;
}

/* 标题栏 */
.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0px;
    background-color: #fff;
    /* border-bottom: 1px solid #d0d0d0; */
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

/* 搜索框样式 */
.search-box {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
}

.search-input {
    width: 200px;
    padding: 8px 15px;
    /* border: 1px solid #e0e0e0; */
    border: none;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #286CED;
}

.search-btn {
    padding: 8px 12px;
    background-color: #ffffff;
    color: #999;
    border: 1px solid #e0e0e0;
    border-left: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    /* font-size: 16px; */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    border: none;
}

/* .search-btn:hover {
    color: #286CED;
    border-color: #286CED;
} */
.search-btn img {
    width: 16px;
    height: 16px;
    margin-right: 12px;
}

/* 分类与推荐区域 */
.category-recommendation {
    display: flex;
    flex-direction: column;
    border: 1px solid #d0d0d0;
    margin-bottom: 20px;
}

/* 分类项 */
.category-item {
    border-bottom: 1px solid #d0d0d0;
}

.category-item:last-child {
    border-bottom: none;
}

/* 分类头部 */
.category-header {
    display: flex;
    /* align-items: center; */
    padding: 20px;
    position: relative;
    overflow: hidden;
    width: 10%;
}

.category-header.fruit {
    background-color: #ffebee;
    /* 浅红色背景 */
    display: flex;
    /* align-items: center; */
    justify-content: center;
}

.category-header.vegetable {
    background-color: #e8f5e9;
    /* 浅绿色背景 */
}

.category-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    /* margin-right: 20px; */
}

.category-subtitle {
    font-size: 14px;
    color: #666;
}

/* 分类内容 */
.category-content {
    display: flex;
    /* padding: 20px; */
    min-height: 300px;

}

/* 分类列表 */
.category-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 0px 40px;
    padding: 20px;
}

.category-group {
    flex-basis: calc(50% - 20px);
    /* 一行显示两个分类 */
    margin-bottom: 10px;
    text-align: left;
}

.group-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    text-align: left;
}

.group-items {
    display: flex;
    flex-wrap: wrap;
    /* gap: 10px; */
}

.group-item {
    font-size: 12px;
    color: #666;
    padding: 1px 2px;
    cursor: pointer;
    transition: color 0.3s;
}

/* 响应式设计调整 */
@media (max-width: 768px) {
    .category-list {
        flex-direction: column;
        /* 移动端单列显示 */
    }

    .category-group {
        flex-basis: 100%;
        /* 移动端单列显示 */
    }
}

.group-item:hover {
    color: #286CED;
}

/* 好货推荐 */
.recommendation {
    width: 488px;
    padding: 20px;
    border-left: 1px solid #d0d0d0;
}

.recommendation-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    text-align: left;
}

.recommendation-items {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}

.recommendation-item {
    /* flex: 1; */
    text-align: center;
    width: 30%;

}

.product-image {
    width: 140px;
    height: 140px;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 8px;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.recommendation-item:hover .product-image img {
    transform: scale(1.05);
}

.product-price {
    font-size: 14px;
    color: #ff6b6b;
    font-weight: bold;
    margin-bottom: 4px;
    text-align: left;

}

.product-name {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;

    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.product-sales {
    font-size: 11px;
    color: #999;
    text-align: left;

}

/* 响应式设计 */
@media (max-width: 1200px) {
    .home-body-third {
        width: 100%;
    }

    .category-content {
        flex-direction: column;
        gap: 20px;
    }

    .recommendation {
        width: 100%;
    }

    .recommendation-items {
        justify-content: space-between;
    }
}

@media (max-width: 768px) {
    .section-header {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .category-list {
        flex-direction: column;
        gap: 20px;
    }

    .recommendation-items {
        flex-wrap: wrap;
    }

    .recommendation-item {
        flex: 0 0 calc(33.33% - 10px);
    }
}
</style>